import { Injectable } from "@angular/core";
import { IEdition } from "@gtmhub/core";
import { storage } from "@gtmhub/core/storage";

@Injectable({
  providedIn: "root",
})
export class EditionService {
  private readonly edition: IEdition;

  constructor() {
    this.edition = storage.get("edition");
  }

  public isFeatureEnabled(feature: string): boolean {
    return this.edition?.features.includes(feature);
  }
}
